import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToPrioritiseTasksReadyForAction');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>The table below describes the types and suggested strategies
                                                that may help you to prioritise.
                                                These are suggested actions only and may not be suitable for
                                                you or your work context. In
                                                reviewing the strategies below, you can customise your own
                                                strategy to help you prioritise.</p>

                                            <table
                                                className="ilead_v_sport tablesrink ilead_v_sport_new_task paraspace uiheading"
                                                border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left" valign="center"
                                                        width="30%">Type
                                                    </th>
                                                    <th className="green_curve1" align="left"
                                                        valign="center" width="60%">Strategy
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen subtiltereg" align="left"
                                                        valign="top" width="30%">
                                                        <p><span
                                                            className="subtiltereg"> Can’t Say No</span></p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="60%">
                                                        <p>You need to stand up for yourself and protect
                                                            your time. By prioritising and
                                                            planning your tasks you will be able to offer
                                                            people evidence as to why you will
                                                            not be able to do the task they are
                                                            requesting.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen subtiltereg" align="left"
                                                        valign="top" width="30%">
                                                        <p><span className="subtiltereg">The Optimist</span>
                                                        </p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="60%">
                                                        <p>You need to engage the help of someone who will
                                                            be able to provide you with
                                                            some realism. Plan a prioritisation session with
                                                            a colleague or secretary once a
                                                            week. Get this person to make you think about
                                                            the time required to carry out
                                                            the tasks you are committing to.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen subtiltereg" align="left"
                                                        valign="top" width="30%">
                                                        <p><span
                                                            className="subtiltereg"> The Perfectionist</span>
                                                        </p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="60%">
                                                        <p>Re-focus some of your perfectionism onto the
                                                            prioritisation process.
                                                            Get this part right and you will be able to
                                                            carry out your tasks.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen " align="left" valign="top"
                                                        width="30%">
                                                        <p><span className="subtiltereg">Not enough time to set priorities</span>
                                                        </p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="60%">
                                                        <p>You don’t have time to plan because you haven’t
                                                            planned your time.
                                                            By not setting priorities you will increase your
                                                            workload as you have
                                                            no grounds to push back tasks.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen subtiltereg" align="left"
                                                        valign="top" width="30%">
                                                        <p><span
                                                            className="subtiltereg">Starter but not completer</span>
                                                        </p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="60%">
                                                        <p>You need to arrange your environment so that you
                                                            cannot start any other tasks
                                                            before the current task is complete. For
                                                            example, go and work in a public library.
                                                            Take with you only the information you need to
                                                            complete your task. Stay there
                                                            until you have finished.</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>SUMMARY
                                            </div>
                                            <p>When you are under a lot of pressure it’s often difficult to
                                                manage conflicting pieces of work, let
                                                alone know where to start! Consider what the potential
                                                de-railer is for your ‘type’ and the
                                                strategies to deal with it. Make sure you choose one (or
                                                more) that will work for you. Good luck.</p>


                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                Further Information
                </span></div>

                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeTimelyDecisions')}>How
                                                        to make timely decisions</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBalanceRiskWithPotentialBenefits')}>How
                                                        to balance risk with potential benefits</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToDeliverEveryTime')}>How
                                                        to deliver every time</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToTakeResponsibility')}>How
                                                        to take responsibility</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToFormulateActionPlans')}>How
                                                        to formulate action plans.</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title referencepad"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"> Vohs, K. et al
                                                    (2008). Making Choices Impairs Subsequent Self-Control:
                                                    A Limited-Resource Account of
                                                    Decision Making, Self-Regulation, and Active Initiative.<span
                                                        className="subtiltereg"> Journal of Personality and Social Psychology,</span> 94,
                                                    883–898.</p></li>
                                                <li><p className="further_info_content">Claessens, B.,
                                                    Eerde, W., Rutte, C., &amp; Roe, R. (2007). A Review of
                                                    the Time Management Literature.<span
                                                        className="subtiltereg">
                           Personnel Review,</span> 36, 255-276.</p></li>
                                                <li><p className="further_info_content"> Lombardo, M.
                                                    (2004).<span
                                                        className="subtiltereg"> For Your Improvement.</span> Lominger
                                                    Ltd.</p></li>


                                                <div className="left-btn">
                                                    <div onClick={this.props.handleChangePage('Page6')}
                                                         className="button-next-previous-done thought"> &lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this._savePageStatus('Thought')}
                                                        className="button-next-previous-done thought">Done
                                                    </div>
                                                </div>

                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}